/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../global-graphql-types';

import { DocumentNode } from 'graphql';
import { CurrentUserFragmentOld } from './CurrentUserFragmentOld';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/extendApolloHooks';
const defaultOptions = {} as const;
export type CurrentCustomerQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentCustomerQuery = { __typename: 'Query', currentCustomer: { __typename: 'Customer', id: number, name: string | null, firstName: string | null, lastName: string | null, email: string, phone: any | null, completeProfile: boolean, anonymous: boolean, authenticationToken: string, referralCode: string, tawkHash: string | null, trackingOptedOut: boolean, managerOfClientCompany: { __typename: 'ClientCompany', id: number, name: string, dashboardUrl: string } | null, amountCredit: { __typename: 'Money', cents: number, formatted: string } } | null };


export const CurrentCustomerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentCustomerQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentUserFragmentOld"}},{"kind":"Field","name":{"kind":"Name","value":"managerOfClientCompany"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUrl"}}]}}]}}]}},...CurrentUserFragmentOld.definitions]} as unknown as DocumentNode;

/**
 * __useCurrentCustomerQuery__
 *
 * To run a query within a React component, call `useCurrentCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCustomerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerQueryDocument, options);
      }
export function useCurrentCustomerQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentCustomerQuery, CurrentCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerQueryDocument, options);
        }
export type CurrentCustomerQueryHookResult = ReturnType<typeof useCurrentCustomerQuery>;
export type CurrentCustomerQueryLazyQueryHookResult = ReturnType<typeof useCurrentCustomerQueryLazyQuery>;
export type CurrentCustomerQueryQueryResult = Apollo.QueryResult<CurrentCustomerQuery, CurrentCustomerQueryVariables>;